import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastSucess } from "../util/toast";

export const buscarCep = createAsyncThunk("/Localizacao/BuscarCep", async (cep: string, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const data = await api.post("/Localizacao/BuscarCep", null, {
      params: { cep: cep },
    });
    toastSucess("Cep encontrado com sucesso");
    dispatch(setLoading(false));

    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarEstado = createAsyncThunk("/Localizacao/ListarEstado", async () => {
  try {
    const data = await api.get("/Localizacao/ListarEstado");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
